
    <svg class="svg-icon icon-frame">
      <use xlink:href="./assets/svg/app-sections.svg#icon-delete-frame"></use>
    </svg>
  